


































































import { HorariosDisponiveisPorDiaProps } from '@/types/interfaces/SolicitacaoCirurgia'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class RoomSchedulingList extends Vue {
  @Prop({ required: true })
  readonly horariosDisponiveis!: HorariosDisponiveisPorDiaProps[]

  @Prop({ required: true })
  readonly initialDate!: string

  @Prop({ required: true })
  readonly finalDate!: string

  @Prop({ required: true })
  readonly isBeforeToday!: boolean

  @Prop({ required: true })
  readonly isToday!: boolean

  @Prop({ required: true })
  readonly hasSchedulingActive!: boolean

  getDayOfWeek(dateString: string) {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString('pt-BR', {
      weekday: 'long',
      timeZone: 'UTC',
    })
  }

  getDayAndMonth(dateString: string) {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString('pt-BR', {
      day: 'numeric',
      month: 'long',
      timeZone: 'UTC',
    })
  }

  getDayAndMonthAndYear(dateString: string) {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString('pt-BR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC',
    })
  }

  onClickSlot(slotPayload, dateSelected) {
    this.$emit('onClickSlot', slotPayload, dateSelected.data)
  }

  onCancelSlotScheduling() {
    this.$emit('onCancelSlotScheduling')
  }

  onChangeFilterDate(operation: 'sum' | 'decrease') {
    this.$emit('onChangeFilterDate', operation)
  }
}
